/** The necessary headers for sending a form-urlencoded request. */
export const formUrlEncodedHeaders = Object.freeze({
    'content-type': 'application/x-www-form-urlencoded',
});
